"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _StateBrowserNetwork = _interopRequireDefault(require("./StateBrowserNetwork"));
var _StateBrowserUsermenu = _interopRequireDefault(require("./StateBrowserUsermenu"));
var _AppSettings = _interopRequireDefault(require("./AppSettings"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _default = exports.default = {
  components: {
    BufferSettings: _BufferSettings.default,
    StateBrowserNetwork: _StateBrowserNetwork.default,
    StateBrowserUsermenu: _StateBrowserUsermenu.default
  },
  props: ['networks', 'sidebarState'],
  data() {
    return {
      self: this,
      pluginUiElements: _GlobalApi.default.singleton().stateBrowserPlugins,
      activePrompt: {
        type: undefined,
        value: undefined
      }
    };
  },
  computed: {
    getNetwork() {
      return this.$state.getActiveNetwork();
    },
    isPersistingState: function isPersistingState() {
      return !!this.$state.persistence;
    },
    isRestrictedServer: function isRestrictedServer() {
      return !!this.$state.settings.restricted;
    },
    networksToShow: function networksToShow() {
      return this.networks.filter(net => !net.hidden);
    }
  },
  created() {
    this.listen(this.$state, 'document.clicked', e => {
      if (!this.activePrompt.type) {
        // Prompt is not open
        return;
      }

      // Clicking anywhere on the page that is not a prompt or close button
      // closes the active prompt
      const ignoreClasses = ['.kiwi-statebrowser-prompt-close', '.kiwi-statebrowser-queries-close', '.kiwi-statebrowser-channel-leave'];
      const ignoreEls = this.$el.querySelectorAll(ignoreClasses.join(', '));

      // ignoreEls.forEach((ignoreEl) => {
      for (let i = 0; i < ignoreEls.length; i++) {
        if (ignoreEls[i].contains(e.target)) {
          return;
        }
      }
      this.activePrompt.type = undefined;
      this.activePrompt.value = undefined;
    });
  },
  methods: {
    clickAddNetwork: function clickAddNetwork() {
      let nick = 'Guest' + Math.floor(Math.random() * 100);
      let network = this.$state.getNetworkFromAddress('');
      if (typeof network === 'undefined') {
        network = this.$state.addNetwork('Network', nick, {});
      }
      network.showServerBuffer('settings');
    },
    clickAppSettings: function clickAppSettings() {
      this.$state.$emit('active.component.toggle', _AppSettings.default);
    },
    hideStatebrowser: function hideStatebrowser() {
      this.$state.$emit('statebrowser.hide');
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowser"]
window._kiwi_exports.components.StateBrowser = exports.default ? exports.default : exports;
